import React from 'react';

const MobileCard = ({
  title,
  subtitle,
  badge,
  fields = [],
  actions,
  onClick,
  className = '',
}) => (
  <div
    className={`mobile-card ${onClick ? 'mobile-card-clickable' : ''} ${className}`}
    onClick={onClick}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={onClick ? (e) => { if (e.key === 'Enter') onClick(e); } : undefined}
  >
    <div className="mobile-card-header">
      <div className="mobile-card-title-group min-w-0">
        {title && <h3 className="mobile-card-title">{title}</h3>}
        {subtitle && <p className="mobile-card-subtitle">{subtitle}</p>}
      </div>
      {badge && <div className="mobile-card-badge flex-shrink-0">{badge}</div>}
    </div>

    {fields.length > 0 && (
      <div className="mobile-card-body">
        {fields
          .filter((f) => f.value != null && f.value !== '' && f.value !== '—')
          .map((field, i) => (
            <div key={field.label || i} className="mobile-card-field">
              <span className="mobile-card-label">{field.label}</span>
              <span className="mobile-card-value">{field.value}</span>
            </div>
          ))}
      </div>
    )}

    {actions && (
      <div className="mobile-card-actions" onClick={(e) => e.stopPropagation()}>
        {actions}
      </div>
    )}
  </div>
);

export default MobileCard;
